import { GraphCard } from '@fareye/common'
import { Flex, Label, RenderControl, Span, InfoIcon } from '@fareye/ui'
import {
  cancelToken,
  FaSortDown,
  FaSortUp,
  get,
  getQueryParams,
  isEmpty,
  responseParser
} from '@fareye/utils'
import queryString from 'query-string'
import React from 'react'
import { labelColor } from '../../../config/colors'
import { inTransitConstant } from '../../../config/constants'

const TransporterPerformanceCard = ({
  match,
  config,
  endDate,
  location,
  startDate,
  searchQuery
}: any) => {
  const source = cancelToken().source()

  const { apiURL, queryParams, apiDataState } = config
  const searchParams = queryString.parse(location.search)
  const { id }: any = match.params
  const idParam = id ? decodeURIComponent(id).split('-to-') : []
  const [toggle, setToggle] = React.useState(false)
  const [apiResponse, setApiResponse] = React.useState({
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
  })
  const query = getQueryParams({
    ...queryParams,
    ...searchParams,
    startDate,
    endDate,
    origin: searchParams?.origin || idParam[0],
    destination: searchParams?.destination || idParam[1],
    ...searchQuery,
    groupBy: 'transporters',
    isActive: 'false'
  })
  async function fetchData() {
    try {
      setApiResponse({ ...apiResponse, isLoading: true })
      const {
        data: { content },
        message,
        error
      } = responseParser(await get(`${apiURL}?${query}`, source.token))
      if (error) {
        setApiResponse({
          ...apiResponse,
          isError: true,
          data: content,
          isSuccess: true,
          isLoading: false,
          message
        })
      } else {
        setApiResponse({
          ...apiResponse,
          isError: false,
          data: content ? content : {},
          isSuccess: true,
          isLoading: false,
          message: isEmpty(content)
            ? apiDataState
              ? apiDataState.noDataMessage
              : 'No Data Found'
            : ''
        })
      }
    } catch (err:any) {
      const { message, error } = responseParser(err.response)
      setApiResponse({
        ...apiResponse,
        isSuccess: false,
        isError: true,
        isLoading: false,
        message
      })
      console.error('App Error:', error)
    }
  }
  React.useEffect(() => {
    fetchData()
    // eslint-disable-line
  }, [query])
  const SortIconStyle = {
    margin: 0,
    fontSize: '15px'
  }
  const data: any = apiResponse.data[0] ? apiResponse.data[0] : []
  const heading = (
    <Flex justifyContentSpaceBetween>
      <Flex justifyContentFlexStart>
        {inTransitConstant.transporterPerformance}
        <InfoIcon
          style={{ marginLeft: 5 }}
          title={`Transporter Wise Top/Bottom Performers`}
        />
      </Flex>
      <Flex
        column
        style={{ margin: '0 5px -16px' }}
        onClick={() => setToggle(!toggle)}
      >
        <FaSortDown
          style={{
            ...SortIconStyle,
            marginBottom: '-9px',
            color: toggle ? '#666' : '#999'
          }}
        />
        <FaSortUp
          style={{
            ...SortIconStyle,
            marginTop: '-7px',
            color: toggle ? '#999' : '#666'
          }}
        />
      </Flex>
    </Flex>
  )
  return (
    <GraphCard graphId="" heading={heading}>
      <Flex
        column
        style={{ color: labelColor.normalText, flex: 1, width: '100%' }}
      >
        <RenderControl variant="xs" state={apiResponse}>
          <Flex
            justifyContentSpaceBetween
            style={{ fontSize: '10px', padding: '3px 0' }}
          >
            <Span>Name</Span>
            <Span>Delivery Score</Span>
          </Flex>
          {data.data &&
            data.data
              .sort((a: any, b: any) => {
                const diff = b.avgOnTimeDeliveryScore - a.avgOnTimeDeliveryScore
                return toggle ? diff : -1 * diff
              })
              .filter((_: any, i: number) => i < 5)
              .map((item: any, index: number) => (
                <Flex
                  justifyContentSpaceBetween
                  key={index}
                  style={{
                    marginTop: '10px',
                    color:
                      item.avgOnTimeDeliveryScore < 50 ? '#C81C1C' : 'inherit'
                  }}
                >
                  <Label variant="h6" style={{ fontWeight: 700 }}>
                    {item.transporter}
                  </Label>
                  <Label variant="h6" style={{ fontWeight: 700 }}>
                    {item.avgOnTimeDeliveryScore}%
                  </Label>
                </Flex>
              ))}
        </RenderControl>
      </Flex>
    </GraphCard>
  )
}

export default TransporterPerformanceCard
